import { useMemo } from "react";

import { getDescriptionId, getErrorId } from "./helpers";

type UseAriaInputPropsOptions = {
  id: string;
  hasHelper: boolean;
  hasError: boolean;
  isOptional?: boolean;
  labelId?: string;
};

const getDescribedBy = ({ id, hasHelper, hasError }: UseAriaInputPropsOptions) => {
  if (hasError) {
    return getErrorId(id);
  }
  if (hasHelper) {
    return getDescriptionId(id);
  }
  return undefined;
};

export type AriaInputProps = {
  id: string;
  "aria-invalid": boolean;
  "aria-describedby": string | undefined;
  "aria-required": boolean;
};

const useAriaInputProps = ({
  id,
  hasHelper,
  hasError,
  isOptional,
  labelId,
}: UseAriaInputPropsOptions): AriaInputProps => {
  return useMemo(
    () => ({
      id,
      ["aria-invalid"]: hasError,
      ["aria-describedby"]: getDescribedBy({ id, hasHelper, hasError }),
      ["aria-required"]: !isOptional,
      ["aria-labelledby"]: labelId,
    }),
    [isOptional, hasError, hasHelper, id, labelId]
  );
};

export default useAriaInputProps;
